import { render, staticRenderFns } from "./freightDetail.vue?vue&type=template&id=de74c73a&scoped=true&"
import script from "./freightDetail.vue?vue&type=script&lang=js&"
export * from "./freightDetail.vue?vue&type=script&lang=js&"
import style0 from "./freightDetail.vue?vue&type=style&index=0&id=de74c73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de74c73a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de74c73a')) {
      api.createRecord('de74c73a', component.options)
    } else {
      api.reload('de74c73a', component.options)
    }
    module.hot.accept("./freightDetail.vue?vue&type=template&id=de74c73a&scoped=true&", function () {
      api.rerender('de74c73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/freightDetail.vue"
export default component.exports